import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className='footer'>
      <h2 className='d-flex justify-content-center align-items-center  p-3 text-white'>
        Copyright © 2021 Masud
      </h2>
    </div>
  );
};

export default Footer;
